import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormService } from 'src/app/services/form/form.service';
import { LoadingScreenComponent } from '../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-case-started',
  template: '<app-loading-screen></app-loading-screen>',
  imports: [LoadingScreenComponent],
})
export class CaseStartedComponent implements OnInit {
  private formService = inject(FormService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    setTimeout(() => {
      this.formService.redirectToCases(
        this.route.snapshot.queryParams.payee_case_reference_id,
      );
    }, 2_000);
  }
}
